import React, { useState } from 'react';
import { X, Smartphone, Building2, Check } from 'lucide-react';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
import { Input } from './ui/Input';
interface TopUpModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function TopUpModal({
  isOpen,
  onClose
}: TopUpModalProps) {
  const [selectedMethod, setSelectedMethod] = useState<'mobile' | 'bank' | null>(null);
  const [amount, setAmount] = useState('');
  const [step, setStep] = useState<'select' | 'input' | 'success'>('select');
  if (!isOpen) return null;
  const handleMethodSelect = (method: 'mobile' | 'bank') => {
    setSelectedMethod(method);
    setStep('input');
  };
  const handleConfirm = () => {
    setStep('success');
    setTimeout(() => {
      onClose();
      setTimeout(() => {
        setStep('select');
        setSelectedMethod(null);
        setAmount('');
      }, 300);
    }, 2000);
  };
  const fee = selectedMethod === 'mobile' ? Math.round(Number(amount) * 0.015) : 0;
  const total = Number(amount) + fee;
  return <div className="fixed inset-0 z-[60] flex items-end justify-center sm:items-center" data-id="element-20">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-21" />

      <div className="relative w-full max-w-md bg-white rounded-t-3xl sm:rounded-3xl p-6 shadow-xl transform transition-transform duration-300 ease-out" data-id="element-22">
        <div className="flex justify-between items-center mb-6" data-id="element-23">
          <h2 className="text-xl font-bold text-[#003366]" data-id="element-24">
            Recharger votre carte
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-25">
            <X size={20} className="text-gray-500" data-id="element-26" />
          </button>
        </div>

        {step === 'select' && <div className="space-y-4" data-id="element-27">
            <button onClick={() => handleMethodSelect('mobile')} className="w-full text-left" data-id="element-28">
              <Card className="hover:border-[#D4A017] transition-colors group" data-id="element-29">
                <div className="flex items-start justify-between mb-2" data-id="element-30">
                  <div className="p-2 bg-orange-100 rounded-lg text-orange-600" data-id="element-31">
                    <Smartphone size={24} data-id="element-32" />
                  </div>
                  <span className="px-2 py-1 bg-blue-50 text-blue-700 text-xs font-medium rounded-full" data-id="element-33">
                    Instantané
                  </span>
                </div>
                <h3 className="font-semibold text-gray-900" data-id="element-34">Mobile Money</h3>
                <p className="text-sm text-gray-500 mt-1" data-id="element-35">Orange Money, Wave</p>
                <div className="mt-3 text-xs text-gray-500" data-id="element-36">
                  Frais :{' '}
                  <span className="font-medium text-gray-900" data-id="element-37">1,5%</span>
                </div>
              </Card>
            </button>

            <button onClick={() => handleMethodSelect('bank')} className="w-full text-left" data-id="element-38">
              <Card className="hover:border-[#D4A017] transition-colors group" data-id="element-39">
                <div className="flex items-start justify-between mb-2" data-id="element-40">
                  <div className="p-2 bg-blue-100 rounded-lg text-blue-600" data-id="element-41">
                    <Building2 size={24} data-id="element-42" />
                  </div>
                  <span className="px-2 py-1 bg-green-50 text-green-700 text-xs font-medium rounded-full" data-id="element-43">
                    Gratuit
                  </span>
                </div>
                <h3 className="font-semibold text-gray-900" data-id="element-44">
                  Virement Bancaire (SPI)
                </h3>
                <p className="text-sm text-gray-500 mt-1" data-id="element-45">
                  Depuis n'importe quelle banque
                </p>
                <div className="mt-3 text-xs text-gray-500" data-id="element-46">
                  Frais : <span className="font-medium text-green-600" data-id="element-47">0%</span>{' '}
                  • Arrive sous 24h
                </div>
              </Card>
            </button>
          </div>}

        {step === 'input' && <div className="space-y-6" data-id="element-48">
            {selectedMethod === 'bank' ? <div className="space-y-4" data-id="element-49">
                <div className="p-4 bg-gray-50 rounded-xl border border-gray-100 space-y-3" data-id="element-50">
                  <div data-id="element-51">
                    <div className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-52">
                      Nom du compte
                    </div>
                    <div className="font-medium text-gray-900" data-id="element-53">
                      ALAL x FBN Collection
                    </div>
                  </div>
                  <div data-id="element-54">
                    <div className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-55">
                      IBAN
                    </div>
                    <div className="font-mono font-medium text-gray-900 text-sm" data-id="element-56">
                      SN012 01011 001234567890 12
                    </div>
                  </div>
                  <div data-id="element-57">
                    <div className="text-xs text-gray-500 uppercase tracking-wide" data-id="element-58">
                      Référence
                    </div>
                    <div className="font-mono font-medium text-gray-900" data-id="element-59">
                      USER-8829
                    </div>
                  </div>
                </div>
                <p className="text-sm text-gray-500 text-center" data-id="element-60">
                  Copiez ces informations dans votre application bancaire. Les
                  virements arrivent généralement sous 24 heures.
                </p>
                <Button fullWidth onClick={() => setStep('select')} variant="outline" data-id="element-61">
                  Retour
                </Button>
              </div> : <>
                <div data-id="element-62">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-63">
                    Montant (FCFA)
                  </label>
                  <Input type="number" placeholder="ex. 10 000" value={amount} onChange={e => setAmount(e.target.value)} className="text-lg font-medium" autoFocus data-id="element-64" />
                </div>

                {amount && <div className="bg-gray-50 p-4 rounded-xl space-y-2" data-id="element-65">
                    <div className="flex justify-between text-sm" data-id="element-66">
                      <span className="text-gray-500" data-id="element-67">Montant</span>
                      <span className="font-medium" data-id="element-68">
                        {Number(amount).toLocaleString('fr-FR')} FCFA
                      </span>
                    </div>
                    <div className="flex justify-between text-sm" data-id="element-69">
                      <span className="text-gray-500" data-id="element-70">Frais (1,5%)</span>
                      <span className="font-medium text-orange-600" data-id="element-71">
                        +{fee.toLocaleString('fr-FR')} FCFA
                      </span>
                    </div>
                    <div className="pt-2 border-t border-gray-200 flex justify-between font-bold text-gray-900" data-id="element-72">
                      <span data-id="element-73">Total à payer</span>
                      <span data-id="element-74">{total.toLocaleString('fr-FR')} FCFA</span>
                    </div>
                  </div>}

                <div className="flex gap-3" data-id="element-75">
                  <Button className="flex-1" variant="outline" onClick={() => setStep('select')} data-id="element-76">
                    Retour
                  </Button>
                  <Button className="flex-1" disabled={!amount} onClick={handleConfirm} data-id="element-77">
                    Confirmer
                  </Button>
                </div>
              </>}
          </div>}

        {step === 'success' && <div className="text-center py-8" data-id="element-78">
            <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-79">
              <Check size={32} data-id="element-80" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-81">
              Rechargement réussi !
            </h3>
            <p className="text-gray-500" data-id="element-82">
              Les fonds ont été ajoutés à votre carte.
            </p>
          </div>}
      </div>
    </div>;
}